import api from "./api";

const bulkUploadService = {
  getSampleCsv: async (categoryId) => {
    const response = await api.get(`/api/bulk-upload/sample/${categoryId}`);
    return response.data;
  },
  
  processUpload: async (categoryId, file) => {
    const formData = new FormData();
    formData.append("category_id", categoryId);
    formData.append("file", file);
    
    const response = await api.post("/api/bulk-upload/process", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
  
  getUploadStatus: async (uploadId) => {
    const response = await api.get(`/api/bulk-upload/status/${uploadId}`);
    return response.data;
  },
  
  getUploadResultCsvData: async (uploadId, type) => {
    const response = await api.get(`/api/bulk-upload/result/${uploadId}/${type}`);
    return response.data;
  }
};

export default bulkUploadService;
